import { mapGetters } from 'vuex';
import { Loading } from 'element-ui';
import mixins from '@/mixins';
import { closest } from '@/utils/util.js';
import { createStripeOrder } from '@/api/shop.js';
import UserCenter from '@/components/UserCenter/UserCenter.vue';

const gems = [
  {
    amount: 3.99,
    id: 'a4c98e8481f54807a61e0a644472cc90',
  },

  // 9折
  {
    amount: 9.99,
    id: '2ab1db2a319b4594b85098375d15628a',
  },

  // 8.6折
  {
    amount: 19.99,
    id: '48ea0d2b38214448bc62c747e50ee807',
  },
];

export default {
  name: 'Home',

  components: {
    UserCenter
  },

  mixins: [mixins],

  data() {
    return {
      currentYear: new Date().getFullYear(),
      products: [
        { icon: '🤖', name: 'Intelligent Bot', desc: 'Intelligent robots are more than just conversational tools—they are your idea incubator, productivity booster, and knowledge vault.', tag: 'Use immediately', type: 1 },
        { icon: '📝', name: 'AutoSummarize', desc: 'AI meeting & document summarization in seconds', tag: 'Coming Soon', type: 0 },
        { icon: '📊', name: 'DataPulse', desc: 'Real-time analytics with natural language queries', tag: 'Coming Soon', type: 0 },
        { icon: '🔮', name: 'ForecastAI', desc: 'Predictive insights for smarter decisions', tag: 'Coming Soon', type: 0 }
      ],
      selectedGemId: gems[0].id,
      gems
    }
  },

  computed: {
    ...mapGetters(['isLogin', 'userName', 'photo', 'balance', 'userId', 'userToken', 'appid']),
  },

  methods: {
    jump(item) {
      if (item.name === 'Intelligent Bot') {
        if (/pre.cozytaps.com/.test(window.location.href)) {
          window.location.href = `https://pre-chat.cozytaps.com/desktop`;
          return;
        }
        
        window.location.href = `https://chat.cozytaps.com/desktop`;
      }
    },

    chooseItem(item) {
      this.selectedGemId = item.id;
    },

    getCurUrl() {
      if (/pre.cozytaps.com/.test(window.location.href)) {
        return 'https://pre.cozytaps.com/desktop';
      }

      return 'https://cozytaps.com/desktop';
    },

    async purchase() {
      if (!this.isLogin) {
        const redirectURL = window.location.href.split('?')[0];

        if (/pre.cozytaps.com/.test(window.location.href)) {
          window.location.href = `https://pre-auth.cozytaps.com/web?appid=01e5928099b54933bcf1ebad2bf81c32&redirect_url=${encodeURIComponent(redirectURL)}`;
          return;
        }
        
        window.location.href = `https://auth.cozytaps.com/web?appid=01e5928099b54933bcf1ebad2bf81c32&redirect_url=${encodeURIComponent(redirectURL)}`;
        return;
      }

      const loading = Loading.service({
        fullscreen: true,
        customClass: 'text-loading',
        text: 'Loading...'
      });

      try {
        const res = await createStripeOrder({
          package_id: this.selectedGemId,
          success_url: this.getCurUrl(),
          cancel_url: this.getCurUrl(),
          token: this.userToken,
          appid: this.appid
        });

        window.location.href = res.data.pay_url;
      }
      catch(err) {}
      loading.close();
    }
  },

  mounted() {}
}



